<!-- E:\workspace_yongli\as_client\src\pages\system\mq_error_log_list.vue -->
<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="处理状态">
                    <c-select name="flag" :options="mqErrorLogFlagDic"></c-select>
                </m-search-item>
                <m-search-item label="队列名称">
                    <c-input name="queues" placeholder="队列名称关键字"></c-input>
                </m-search-item>
                <m-search-item label="创建时间" colspan="2">
                    <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" prepend-icon="tf-add" @click="openSendDialog">发送补数据消息</c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="队列名称"
                        name="queues"
                        width="160"
                ></c-table-column>

                <c-table-column
                        label="消息体"
                        name="message"
                        width="280"
                ></c-table-column>

                <c-table-column
                        label="错误信息"
                        name="error_log"
                        width="260"
                >
                    <template #default="{data}">
                        <span style="color: #FF5555;">{{data.error_log || '-'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="Exchange"
                        name="exchange"
                        width="120"
                >
                    <template #default="{data}">
                        {{data.exchange || '-'}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="Routing Key"
                        name="routing_key"
                        width="140"
                >
                    <template #default="{data}">
                        {{data.routing_key || '-'}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="处理状态"
                        name="flag"
                        width="80"
                >
                    <template #default="{data}">
                        <c-state dict="mqErrorLogFlagDic" tag :value="data.flag"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="160"
                        button-limit="3"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-view" @click="showDetail(data)">详情</c-table-button>
                        <c-table-button v-if="data.flag == 0" icon="tf-reset-password" @click="retryMessage(data)">重新投递</c-table-button>
                        <c-table-button v-if="data.flag == 0" icon="tf-edit" @click="markProcessed(data)">标记已处理</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState(['mqErrorLogFlagDic'])
    },

    data() {
        return {}
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/sys/mq/error/log/list',
                data,
                success: () => {}
            });
        },

        showDetail(data) {
            this.request({
                url: '/sys/mq/error/log/detail',
                data: {id: data.id},
                success: detail => {
                    this.globalDialog('mqErrorLogDetail', {
                        data: {detail}
                    });
                }
            });
        },

        retryMessage(data) {
            this.$confirm({
                message: '确定要重新投递该MQ消息吗？',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/sys/mq/error/log/retry',
                        data: {id: data.id},
                        loading: true,
                        success: (result, message) => {
                            this.$message({
                                message: message || '投递成功',
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },
                cancel: () => {},
            });
        },

        markProcessed(data) {
            this.$confirm({
                message: '确定将该条错误日志标记为已处理吗？标记后将不会重新投递。',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/sys/mq/error/log/mark',
                        data: {id: data.id},
                        loading: true,
                        success: (result, message) => {
                            this.$message({
                                message: message || '操作成功',
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },
                cancel: () => {},
            });
        },

        openSendDialog() {
            this.globalDialog('mqMessageSend', {}, () => {
                this.$refs.list.update();
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>